#import "./parent-child-fragment.graphql"

fragment AccountHierarchyFragment on Account {
    id
    name
    parentAccount {
        ...ParentChildFragment
    }
    childAccounts(first: 1000) {
        totalCount
        edges {
            node {
                ...ParentChildFragment
            }
        }
    }
}
